import { BoxProps, Button, HStack, Link, Text, useBreakpointValue, VStack } from '@chakra-ui/react'
import { useAuth, usePin } from 'context'
import { sendMessageToApp } from 'services/connectToApp'
import { themeColors } from 'theme'

import CustomDivider from 'components/CustomDivider'
import { ContactUsIcon, LogoutIcon, MailIcon } from 'components/SVGS'

import { NavigationItem } from '../NavigationItem'

import { navigationOptions } from './navigationOptions'

type SidebarContentProps = BoxProps


export const SidebarContent: React.FC<SidebarContentProps> = ({ ...props }) => {
  const { logout } = useAuth()
  const { pinState: { state: { isHavePin } } } = usePin()
  const { icon: { interrogationIconColor, secondaryIconColor }, text: { bgInfoColorText } } = themeColors
  const breakpoint = useBreakpointValue({ base: 'small', md: 'desktop' })




  return (
    <VStack
      as="nav"
      left="0"
      zIndex="sticky"
      h='full'
      my={5}
      px={2}
      borderRadius={20}
      overflowX="hidden"
      overflowY="auto"
      {...props}
    >
      <VStack justifyContent='space-between' h='full' spacing={4}>
        <VStack direction="column" p={2} justifyContent='center' alignItems='center' spacing={6}>
          {navigationOptions.map(x =>
            x.key === 1 &&
            <NavigationItem key={x.key} icon={x.icon} route={x.route} isNavLink={x.isNavLink}>{x.name}</NavigationItem>)
          }
          <CustomDivider />
          {navigationOptions.map(x => isHavePin
            ? x.key === 2 &&
            <NavigationItem key={x.key} icon={x.icon} route={x.route} isNavLink={x.isNavLink}>{x.name}</NavigationItem>
            : x.key === 3 &&
            <NavigationItem key={x.key} icon={x.icon} route={x.route} isNavLink={x.isNavLink}>{x.name}</NavigationItem>)
          }
          {navigationOptions.map(x =>
            x.key === 4 &&
            <NavigationItem
            onClick={() => sendMessageToApp({ route:x.routeToApp, link:x.externalUrl })}
            key={x.key} icon={x.icon} route={x.route}
            isNavLink={x.isNavLink}>
            {x.name}
            </NavigationItem>)
          }
          {navigationOptions.map(x =>
            x.key === 5 &&
                <NavigationItem
                onClick={() => sendMessageToApp({ route:x.routeToApp, link:x.externalUrl })}
                key={x.key} icon={x.icon} route={x.route}
                isNavLink={x.isNavLink}>
                {x.name}
                </NavigationItem>
             )
          }
          <CustomDivider />
          {
            breakpoint === 'small' &&
            <Button onClick={logout} cursor="pointer" rightIcon={<LogoutIcon size={8} fill={secondaryIconColor} />}>
              Cerrar sesión
            </Button>
          }
        </VStack>
        <VStack>
          <ContactUsIcon size={28} fill={interrogationIconColor} />
          <Text variant={'MD_SB'} color={interrogationIconColor}>Contáctanos</Text>
          <HStack>
            <MailIcon fill={interrogationIconColor} size={6} />
            <Link color={bgInfoColorText} href="mailto:wicar@grupokaufmann.com ">
              <Text variant='SM' color={bgInfoColorText}>wicar@grupokaufmann.com </Text>
            </Link>
          </HStack>
        </VStack>
      </VStack>
    </VStack>
  )
}
